// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_wrapper__1f5D0 {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.login_card__lVKvK {
  width: 100%;
  max-width: 400px;
  border: 1px solid #b4b4b4;
  border-radius: 8px;
  padding: 24px;
  margin: 20px;
}

.login_title__QcRCO {
  text-align: center;
  color: #737373;
  margin-bottom: 20px;
}

.login_formContainer__PT3WE {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.login_formGroup__kuiz4 input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #b4b4b4;
  border-radius: 6px;
  font-size: 14px;
  outline: 0;
}

.login_passwordRow__Nsuwp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}

.login_togglePassword__ntlbm {
  font-size: 13px;
  color: #a6a6a6;
  cursor: pointer;
}

.login_loginBtn__kVtUG {
  width: 150px;
  height: 40px;
  background: #55883b;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  margin: 20px auto 0;
  display: block;
}

.login_loginBtn__kVtUG:disabled {
  opacity: 0.6;
}

.login_divider__qwKTU {
  text-align: center;
  margin: 16px 0;
  color: #999;
}

.login_socialBtn__Tz9-N {
  width: 100%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.login_socialBtn__Tz9-N img {
  width: 20px;
  height: 20px;
}

.login_forgotText__ePeZf {
  margin-top: 16px;
  color: #737373;
}

.login_resetLink__7EN-X {
  color: #183d8b;
  cursor: pointer;
}

.login_resetLink__7EN-X:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Auth/Login/login.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".wrapper {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.card {\n  width: 100%;\n  max-width: 400px;\n  border: 1px solid #b4b4b4;\n  border-radius: 8px;\n  padding: 24px;\n  margin: 20px;\n}\n\n.title {\n  text-align: center;\n  color: #737373;\n  margin-bottom: 20px;\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.formGroup input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #b4b4b4;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: 0;\n}\n\n.passwordRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 6px;\n}\n\n.togglePassword {\n  font-size: 13px;\n  color: #a6a6a6;\n  cursor: pointer;\n}\n\n.loginBtn {\n  width: 150px;\n  height: 40px;\n  background: #55883b;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  cursor: pointer;\n  margin: 20px auto 0;\n  display: block;\n}\n\n.loginBtn:disabled {\n  opacity: 0.6;\n}\n\n.divider {\n  text-align: center;\n  margin: 16px 0;\n  color: #999;\n}\n\n.socialBtn {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n\n.socialBtn img {\n  width: 20px;\n  height: 20px;\n}\n\n.forgotText {\n  margin-top: 16px;\n  color: #737373;\n}\n\n.resetLink {\n  color: #183d8b;\n  cursor: pointer;\n}\n\n.resetLink:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `login_wrapper__1f5D0`,
	"card": `login_card__lVKvK`,
	"title": `login_title__QcRCO`,
	"formContainer": `login_formContainer__PT3WE`,
	"formGroup": `login_formGroup__kuiz4`,
	"passwordRow": `login_passwordRow__Nsuwp`,
	"togglePassword": `login_togglePassword__ntlbm`,
	"loginBtn": `login_loginBtn__kVtUG`,
	"divider": `login_divider__qwKTU`,
	"socialBtn": `login_socialBtn__Tz9-N`,
	"forgotText": `login_forgotText__ePeZf`,
	"resetLink": `login_resetLink__7EN-X`
};
export default ___CSS_LOADER_EXPORT___;
